var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-item',[_c('v-list-item-avatar',[_c('v-icon',[_vm._v(_vm._s(_vm.control.icon))])],1),_c('v-list-item-content',[_vm._v(" "+_vm._s(_vm.control.name)+" ")])],1),(_vm.control.divider)?_c('v-divider'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }